/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc
 */
import * as References from './PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getProducts
 */
export const GET_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getProducts';
export const GET_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCTS_QUERY_FIELD_NAME,
  args: ['countryCode', 'productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProductsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductsV2
 */
export const GET_PUBLIC_PRODUCTS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductsV2';
export const GET_PUBLIC_PRODUCTS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCTS_V2_QUERY_FIELD_NAME,
  args: ['countryCode', 'productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPublicProductsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getBundle
 */
export const GET_BUNDLE_MUTATION_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getBundle';
export const GET_BUNDLE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_BUNDLE_MUTATION_FIELD_NAME,
  args: ['products', 'countryCode', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getBundleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getAddOns
 */
export const GET_ADD_ONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getAddOns';
export const GET_ADD_ONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ADD_ONS_QUERY_FIELD_NAME,
  args: ['countryCode', 'productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAddOnsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicAddOnsV2
 */
export const GET_PUBLIC_ADD_ONS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicAddOnsV2';
export const GET_PUBLIC_ADD_ONS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_ADD_ONS_V2_QUERY_FIELD_NAME,
  args: ['countryCode', 'productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getPublicAddOnsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getGrowthPurchaseOptions
 */
export const GET_GROWTH_PURCHASE_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getGrowthPurchaseOptions';
export const GET_GROWTH_PURCHASE_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GROWTH_PURCHASE_OPTIONS_QUERY_FIELD_NAME,
  args: ['products', 'currencyCode', 'preferredCountry', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getGrowthPurchaseOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicGrowthPurchaseOptionsV2
 */
export const GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicGrowthPurchaseOptionsV2';
export const GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_GROWTH_PURCHASE_OPTIONS_V2_QUERY_FIELD_NAME,
  args: ['products', 'currencyCode', 'preferredCountry', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getPublicGrowthPurchaseOptionsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getGrowthPurchaseOptionsUsingCombinedTerms
 */
export const GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getGrowthPurchaseOptionsUsingCombinedTerms';
export const GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GROWTH_PURCHASE_OPTIONS_USING_COMBINED_TERMS_QUERY_FIELD_NAME,
  args: ['currencyCode', 'products', 'countryCode', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getGrowthPurchaseOptionsUsingCombinedTermsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicCurrencyResponse
 */
export const GET_PUBLIC_CURRENCY_RESPONSE_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicCurrencyResponse';
export const GET_PUBLIC_CURRENCY_RESPONSE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_CURRENCY_RESPONSE_QUERY_FIELD_NAME,
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getPublicCurrencyResponseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicCurrencyV2
 */
export const GET_PUBLIC_CURRENCY_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicCurrencyV2';
export const GET_PUBLIC_CURRENCY_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_CURRENCY_V2_QUERY_FIELD_NAME,
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getPublicCurrencyV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicPhoneNumber
 */
export const GET_PUBLIC_PHONE_NUMBER_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicPhoneNumber';
export const GET_PUBLIC_PHONE_NUMBER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PHONE_NUMBER_QUERY_FIELD_NAME,
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getPublicPhoneNumberRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicPhoneNumberV2
 */
export const GET_PUBLIC_PHONE_NUMBER_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicPhoneNumberV2';
export const GET_PUBLIC_PHONE_NUMBER_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PHONE_NUMBER_V2_QUERY_FIELD_NAME,
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getPublicPhoneNumberV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicFeatureFlags
 */
export const GET_PUBLIC_FEATURE_FLAGS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicFeatureFlags';
export const GET_PUBLIC_FEATURE_FLAGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_FEATURE_FLAGS_QUERY_FIELD_NAME,
  args: ['utk', 'browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.getPublicFeatureFlagsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicFeatureFlagsV2
 */
export const GET_PUBLIC_FEATURE_FLAGS_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicFeatureFlagsV2';
export const GET_PUBLIC_FEATURE_FLAGS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_FEATURE_FLAGS_V2_QUERY_FIELD_NAME,
  args: ['utk', 'browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getPublicFeatureFlagsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicPricingPageDetails
 */
export const GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicPricingPageDetails';
export const GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY_FIELD_NAME,
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getPublicPricingPageDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductUseCasesV2
 */
export const GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductUseCasesV2';
export const GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_USE_CASES_V2_QUERY_FIELD_NAME,
  args: ['browserLocale', 'useCaseGroups'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getPublicProductUseCasesV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductUseCasesV3
 */
export const GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductUseCasesV3';
export const GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_USE_CASES_V3_QUERY_FIELD_NAME,
  args: ['browserLocale', 'useCaseGroups'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getPublicProductUseCasesV3Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductPlan
 */
export const GET_PUBLIC_PRODUCT_PLAN_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductPlan';
export const GET_PUBLIC_PRODUCT_PLAN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_PLAN_QUERY_FIELD_NAME,
  args: ['productCart', 'browserLocale', 'currencyCode', 'contactQuantity', 'selectedUseCaseGroups'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.getPublicProductPlanRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductBadges
 */
export const GET_PUBLIC_PRODUCT_BADGES_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductBadges';
export const GET_PUBLIC_PRODUCT_BADGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_BADGES_QUERY_FIELD_NAME,
  args: ['productApiNames', 'seatCount'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.getPublicProductBadgesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductTierOptions
 */
export const GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductTierOptions';
export const GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_TIER_OPTIONS_QUERY_FIELD_NAME,
  args: ['browserLocale', 'currencyCode', 'teamSizeConfiguration', 'contactQuantity', 'selectedUseCaseGroups', 'activeFeatureFlags'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.getPublicProductTierOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getProductsBySkuId
 */
export const GET_PRODUCTS_BY_SKU_ID_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getProductsBySkuId';
export const GET_PRODUCTS_BY_SKU_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCTS_BY_SKU_ID_QUERY_FIELD_NAME,
  args: ['skuIds'],
  fetcher(request, ctx) {
    var _ctx$customClient21;
    return ((_ctx$customClient21 = ctx.customClient) !== null && _ctx$customClient21 !== void 0 ? _ctx$customClient21 : chirpClient).call(References.getProductsBySkuIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductConfigurationOptions
 */
export const GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductConfigurationOptions';
export const GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_CONFIGURATION_OPTIONS_QUERY_FIELD_NAME,
  args: ['browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient22;
    return ((_ctx$customClient22 = ctx.customClient) !== null && _ctx$customClient22 !== void 0 ? _ctx$customClient22 : chirpClient).call(References.getPublicProductConfigurationOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicCabProducts
 */
export const GET_PUBLIC_CAB_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicCabProducts';
export const GET_PUBLIC_CAB_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_CAB_PRODUCTS_QUERY_FIELD_NAME,
  args: ['countryCode'],
  fetcher(request, ctx) {
    var _ctx$customClient23;
    return ((_ctx$customClient23 = ctx.customClient) !== null && _ctx$customClient23 !== void 0 ? _ctx$customClient23 : chirpClient).call(References.getPublicCabProductsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicProductGroups
 */
export const GET_PUBLIC_PRODUCT_GROUPS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicProductGroups';
export const GET_PUBLIC_PRODUCT_GROUPS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_PRODUCT_GROUPS_QUERY_FIELD_NAME,
  args: ['productGroup', 'currencyCode', 'preferredCountry', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient24;
    return ((_ctx$customClient24 = ctx.customClient) !== null && _ctx$customClient24 !== void 0 ? _ctx$customClient24 : chirpClient).call(References.getPublicProductGroupsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getCreditActions
 */
export const GET_CREDIT_ACTIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getCreditActions';
export const GET_CREDIT_ACTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CREDIT_ACTIONS_QUERY_FIELD_NAME,
  args: ['totalCredits', 'useCaseGroups', 'productApiName', 'countryCode', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient25;
    return ((_ctx$customClient25 = ctx.customClient) !== null && _ctx$customClient25 !== void 0 ? _ctx$customClient25 : chirpClient).call(References.getCreditActionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc#getPublicRecommendations
 */
export const GET_PUBLIC_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicProductRpc_getPublicRecommendations';
export const GET_PUBLIC_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['companyDomain', 'browserLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient26;
    return ((_ctx$customClient26 = ctx.customClient) !== null && _ctx$customClient26 !== void 0 ? _ctx$customClient26 : chirpClient).call(References.getPublicRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});